<template>
  <v-container>
    <div>
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div>
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"></FilterForm>
    </div>

    <v-divider class="my-2"></v-divider>

    <v-data-table class="mt-6" :headers="headers" :items="items" item-key="SKU" :single-expand="true"
      :expanded.sync="expanded" show-expand :search="search" dense :options.sync="options"
      :server-items-length="totalItems" :loading="loading" :footer-props="{
        'items-per-page-options': [50, 100, 150, 200, 500],
      }" height="65vh" fixed-header>
      <template v-slot:top>
        <v-text-field v-model="search" label="Search" class="mb-1" outlined dense hide-details="auto"></v-text-field>
      </template>
      <template v-slot:[`item.Brand`]="{ item }">
        <tr>
          <td>
            <span>{{ item.Brand }}</span><br />
            <span class="grey--text"> Currency: {{ item.Currency }} </span>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.stock`]="{ item }">
        <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
          {{ item.stock }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="40" @click="openHistory(item)" color="accent">mdi-eye-circle</v-icon>
          </template>
          <span>View product history</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ProductInfo :product="item"></ProductInfo>
        </td>
      </template>
    </v-data-table>

    <ProductHistoryDialog :product="productForHistory" ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";

export default {
  name: "Exported",
  props: {},
  components: {
    FilterForm,
    ProductInfo,
    ProductHistoryDialog,
  },
  data: () => ({
    headers: [
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "STOCK", value: "stock", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    loadingProducts: false,
    search: "",
    productForHistory: {},
    // NEW PROPERTIES FOR PAGINATION
    options: {},
    totalItems: 0,
    currentFilters: [],
    loading: false,
  }),
  watch: {
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  methods: {
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    formatFilterValues(filters) {
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["Described", "equals", false]);

      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }

      // NEW: Store filters for pagination
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
    filterProducts(data) {
      // NEW: Get pagination params
      const { page, itemsPerPage } = this.options;

      // NEW: Set loading state
      this.loading = true;

      this.$store
        .dispatch("filterProducts", {
          filters: data,
          page: page || 1,
          limit: itemsPerPage || 100
        })
        .then((response) => {
          let filteredItems = [];

          // NEW: Handle new response format
          if (response.data.data) {
            // Filter out Legacy items from paginated response
            filteredItems = response.data.data.filter(
              (item) => item.ExportState != "Legacy"
            );
            this.items = filteredItems;
            // Adjust total items count after filtering
            this.totalItems = response.data.pagination?.total || filteredItems.length;
          } else {
            // Fallback for old format
            filteredItems = response.data.filter(
              (item) => item.ExportState != "Legacy"
            );
            this.items = filteredItems;
            this.totalItems = filteredItems.length;
          }

          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
        })
        .catch((error) => {
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = "";
          errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong while filtering.";

          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
  },
};
</script>